module.exports = __webpack_public_path__ + "static/media/csv.64290aaf.svg";